<template>
  <gj-popover
      v-model="visible"
      placement="top"
      width="420"
      trigger="manual"
      :title="popTitle"
      @show="pageShow = true"
      @close="closeEditMemo()">
    <template slot="reference">
      <el-row
          type="flex"
          align="middle"
          :style="{'justify-content': align === 'right' ? 'flex-end' : ''}">
        <div class="text-ellipsis-2"><slot>{{value}}</slot></div>
        <div :class="{'gj-cell-display-switch': tableCellEdit}"
             @click="memoEdit()">
          <i class="el-icon-edit pen-icon"></i>
        </div>
      </el-row>
    </template>
    <el-form ref="form" :model="form" v-if="pageShow">
      <el-row>
        <el-col :span="8">
          <el-form-item prop="feeWay" >
            <gj-select
                v-model="form.feeWay"
                :options="ExpensesTypeEnum.options"
                :clearable="false"
                width="90%"
            ></gj-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <gj-select-input
              :value="form.feeObj"
              :width="['120px', '160px']"
              :placeholder="['币种', '请输入']"
              :search="false"
              :options="financeCurrencysOption"
          ></gj-select-input>
        </el-col>
      </el-row>
    </el-form>
    <div style="text-align: right;">
      <gj-button :size="'mini'" @click="closeEditMemo()">取消</gj-button>
      <gj-button
          :size="'mini'"
          type="primary"
          :disabled="confirmDisabled"
          @click="confirm()"
          :loading="loading"
      >确定</gj-button>
    </div>
  </gj-popover>
</template>

<script>
import GjTextarea from "@/components/input/gj-textarea";
import GjPopover from "@/components/popover/gj-popover";
import {isMeaningless} from "@/utils/common";
import {ExpensesTypeEnum} from "@/views/modules/finance/finance-profit-report/common/enum";
import {currencysOption, financeCurrencysOption} from "@/utils/options";
import _ from "lodash";
export default {
  name: "edit-custom-fee-modal",
  components: {GjPopover},
  props: {
    customId:{
      type: String
    },
    msku:{
      type: String
    },
    marketId:{
      type: String
    },
    tabsActive:{
      type: String
    },
    value: null,
    onConfirm: {
      type: Function
    },
    item: {
      type: Object
    },
    popTitle: {
      type: String
    },
    tableCellEdit: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'left'
    },
    validator: {
      type: Function,
      default: () => true
    },

  },
  watch: {
    value: {
      handler(value) {
        this.dataValue = value;
      },
      immediate: true
    }
  },
  data() {
    return {
      ExpensesTypeEnum: ExpensesTypeEnum,
      // currencysOption: currencysOption.map(v=> ({id: v.id, text: v.id})),    //不需要原币种
      financeCurrencysOption: financeCurrencysOption.filter(v=> v.id),
      pageShow: false,
      dataValue: null,
      visible: false,
      loading: false,
      form: {
        feeWay: 1,
        currency: this.item.currency || 'USD',
        feePrice: 0,
        feeItemId: "",
        feeMonth: '',
        feeObj:{
          key: this.item.currency || 'USD',
          value: 0,
        }
      }
    }
  },
  created() {
    this.dataValue = this.value;
    this.form.feeItemId = this.customId;
    this.form.feePrice = _.cloneDeep(this.value);
    this.form.feeObj.value = _.cloneDeep(this.value);
    this.form.marketId = this.marketId;
    this.form.feeMonth = this.item.standardDate;
    if(this.tabsActive === "msku"){
      this.form.msku = this.msku;
    }
  },
  computed: {
    confirmDisabled() {
      return !this.validator(this.dataValue);
    }
  },
  methods: {
    memoEdit() {
      this.visible = true;
    },
    closeEditMemo() {
      this.visible = false;
      this.dataValue = this.value;
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if(valid){
          this.loading = true;
          this.form.currency = this.form.feeObj.key;
          this.form.feePrice = Number(this.form.feeObj.value);
          this.onConfirm(this.form, this.item, () => {
            this.visible = false;
            this.loading = false;
          }, () => {
            this.loading = false;
          });
        }
      })
    },
  }
}
</script>

<style scoped>
.pen-icon {
  cursor: pointer;
  margin-left: 5px;
  font-size: 13px;
}
</style>
